import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DestinationCommunicationService {
  private selectedDestinationSubject = new BehaviorSubject<any | null>(null);
  
  // Observable that components can subscribe to
  selectedDestination$: Observable<any | null> = this.selectedDestinationSubject.asObservable();
  
  constructor() { }
  
  // Method to set the selected destination
  setSelectedDestination(destination: any | null): void {
    this.selectedDestinationSubject.next(destination);
  }
  
  // Method to get the current value (synchronous)
  getCurrentDestination(): any | null {
    return this.selectedDestinationSubject.value;
  }
  
  // Method to clear the destination
  clearDestination(): void {
    this.selectedDestinationSubject.next(null);
  }
}
